<template>
	<div>
		<!-- <DashVideo
			:protData="protData"
			:customData="base64Data"
			:vid="video_id"
			:playback="playbackURL"
			v-if="showVideo && !showSafariPlayer"
		/> -->
		<!-- <SafariPlayer
			v-if="showVideo && showSafariPlayer"
			:safariPlayback="safariPlaybackURL"
			:customData="base64Data"
			:playback="playbackURL"
		/> -->
		<NewVideoPlayer
			:protData="protData"
			:customData="base64Data"
			:vid="video_id"
			:playback="playbackURL"
			v-if="showVideo"
		/>
		<div v-if="showPopup" class="notfound-container d-flex flex-column h-100">
			<section class="col-md-6 container">
				<div class="form-upgrade card">
					<div class="row">
						<div class="col-md-12">
							<div class="upgrade-heading">
								<h2 class="py-4 heading">No Active Subscription</h2>
							</div>
							<div class="upgrade-plan py-3">
								<p>
									You have no active subscription, Kindly add subscription to
									start watching movies
								</p>
								<div class="buttons">
									<a
										@click="onclickaddSubscription"
										class="btn btn-outline-light btn-lg "
									>
										Add Subscription
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		</div>
		<div
			v-if="showScreenLimitError"
			class="notfound-container d-flex flex-column h-100"
		>
			<section class="col-md-6 container">
				<div class="form-upgrade2 card">
					<div class="row">
						<div class="col-md-12">
							<div class="upgrade-heading py-3">
								<h2>Screen Limit</h2>
							</div>
							<div class="upgrade-plan py-3">
								<p class="upgrade-plan2 py-3">
									Too many people are using your account right now.Upgrade your
									plan or stop playing on one of these screens:
								</p>
							</div>
							<div class="upgrade-plan py-3">
								<p class="font-semibold upgrade-plan2 py-3">Web Browser-void</p>
								<p class="font-semibold upgrade-plan2 py-3">Mobile App-Grey</p>
							</div>
							<p class="mt-2 buttons">
								<a href="/#/home" class="btn btn-outline-light mx-2">
									Cancel
								</a>
								<a @click="retryScreenLimit" class="btn btn-outline-light mx-2">
									Retry
								</a>
								<a href="/#/changesubscription" class="btn btn-primary mx-2">
									Upgrade to 5 screens
								</a>
							</p>
						</div>
					</div>
				</div>
			</section>
		</div>
	</div>
</template>

<script>
import DashVideo from "@/pages/player/DashVideo";
import Category from "@/components/Category.vue";
import SafariPlayer from "@/pages/player/SafariPlayer.vue";
import NewVideoPlayer from "@/pages/player/NewVideoPlayer.vue"
// import firebase from "../config";
import duid from "../service/getDuid";
import axios from "axios";
export default {
	name: "ViewVideo",
	components: {
		DashVideo,
		Category,
		SafariPlayer,
		NewVideoPlayer
	},
	computed: {
		protData() {
			let drmData = {
				"com.widevine.alpha": {
					serverURL:
						"https://lic.drmtoday.com/license-proxy-widevine/cenc/?specConform=true",
					httpRequestHeaders: {
						//"x-dt-custom-data":
						//	"ewoidXNlcklkIjogIjVlMTBjOTBmYTUwYmIzMWZkOTNhN2VkNSIsCiJzZXNzaW9uSWQiOiAiazhqZGY3ajRpaGY3NGZoazhqZGY3ajRpaGY3NGZoazhqZGY3ajRpaGY3NGZoazhqZGY3ajRpaGY3NGZoIiwKIm1lcmNoYW50IjogImliYWthdHYiCn0=",
						"x-dt-custom-data": this.base64Data,
					},
				},
			};
			return drmData;
		},
		showplay() {
			if (this.$store.state.globalconfigs.enable_play == "false") {
				return false;
			} else {
				return true;
			}
		},
		getvideoID() {
			var vid = this.$route.params.vid;
			return vid;
		},
	},
	filters: {
		trimdis: function(value) {
			return value.slice(0, 80) + "...";
		},
	},
	mounted() {
		//  this.$store.commit("setLoader", true);
		this.checkSpecialPlan();
		window.scroll(0, 0);
		this.jsonDataToBase64Data();
		HelpCrunch("hideChatWidget");
		let isSafari =
			navigator.vendor.match(/apple/i) &&
			!navigator.userAgent.match(/crios/i) &&
			!navigator.userAgent.match(/fxios/i) &&
			!navigator.userAgent.match(/Opera|OPT\//);

		if (isSafari) {
			// Safari browser is usedq
			this.showSafariPlayer = true;
		} else {
			// Other browser is used
		}
	},

	beforeRouteEnter(to, from, next) {
		//this.$store.commit('setLoader', false);
		next();
	},
	beforeDestroy() {
		clearInterval(this.interval);
	},

	data() {
		return {
			jsonData: {
				userId: "",
				sessionId: "",
				merchant: "ibakatv",
			},
			str: "",
			base64Data: "",
			showVideo: false,
			category_data: {},
			currentVideo: {},
			currentCat: "",
			options: null,
			duidVal: null,
			interval: null,
			playbackURL: "",
			session_id: "",
			user_id: "",
			video_name: "",
			firebasePingTime: "",
			showPopup: false,
			showScreenLimitError: false,
			showSafariPlayer: true,
			safariPlaybackURL: "",
		};
	},
	methods: {
		jsonDataToBase64Data() {
			this.jsonData.userId = this.user_id;
			this.jsonData.sessionId = this.session_id;
			this.str = JSON.stringify(this.jsonData);
			this.base64Data = btoa(this.str);
		},
		getDuidValue() {
			this.duidVal = duid.getDuid();
		},
		deviceName() {
			var test = function(regexp) {
				return regexp.test(window.navigator.userAgent);
			};
			switch (true) {
				case test(/edg/i):
					return "Microsoft Edge";
				case test(/trident/i):
					return "Microsoft Internet Explorer";
				case test(/firefox|fxios/i):
					return "Mozilla Firefox";
				case test(/opr\//i):
					return "Opera";
				case test(/ucbrowser/i):
					return "UC Browser";
				case test(/samsungbrowser/i):
					return "Samsung Browser";
				case test(/chrome|chromium|crios/i):
					return "Google Chrome";
				case test(/safari/i):
					return "Apple Safari";
				default:
					return "Other";
			}
		},

		firebasePushData() {
			var currentDate = new Date();
			var timeStr = currentDate.toString();
			//var UTCtime = CurrentDate.getUTCDate();
			const obj = {
				device_name: this.deviceName(), // can get from config device_name
				device_id: this.duidVal, // on load of webapp for first time genrating random string duid and use it
				userId: this.user_id, // can get from account.user.profile.id
				video_id: this.video_id, // current video id
				video_name: this.video_name, // current video name
				session_id: this.session_id, //
				lastSessionAt: { ".sv": "timestamp" },
				customerId: this.$store.state.customerid, // current video session can get from playback url responce
			};
			axios
				.post(
					this.$store.getters.getGlobalConfigs.firebase_base_url +
						this.user_id +
						"-" +
						this.duidVal +
						".json?auth=" +
						this.$store.getters.getGlobalConfigs.firebase_auth_id,
					obj
				)
				.then(function(response) {});
		},

		firebaseData() {
			this.interval = setInterval(this.firebasePushData, this.firebasePingTime);
		},

		my_favourite() {
			for (var i = 0; i < this.$store.state.user.mylist.length; i++) {
				var item = this.$store.state.user.mylist[i];
				if (item.id == this.currentVideo.id) return true;
			}
			return false;
		},
		resumePlay() {
			this.$store
				.dispatch("getVideoById", this.$route.params.vid)
				.then((res) => {
					this.$store.commit("setresumelistData", [
						res._embedded.collections[0],
					]);
				});
		},
		handleFav() {},
		onclickaddSubscription() {
			this.$router.push("/packages");
		},

		retryScreenLimit() {
			window.location.reload();
		},
		getText(val) {
			return this.$store.getters.getGlobalConfigs[val];
		},
		checkSpecialPlan() {
			if (this.$store.state.user.userInfo.subscriptions.length > 0 && this.$store.state.user.userInfo.subscriptions[0].package_id == this.getText('restriction_package')) {
				setTimeout(() => {
					this.$store.commit("showSpecialPopUp", true);
				}, 10)
			}
		}
	},
	created() {
		this.$store.commit("setLoader", true);
		this.checkSpecialPlan();
		this.video_id = this.$route.params.vid;
		this.$store.commit("showdefaultnav", false);
		this.$store.commit("showdefaultFooter", false);
		this.getDuidValue();
		if (document.body.requestFullscreen) {
			document.body.requestFullscreen();
		}

		if (this.$store.getters.getGlobalConfigs.firebase_ping_time) {
			this.firebasePingTime = Number(
				this.$store.getters.getGlobalConfigs.firebase_ping_time
			);
		} else {
			this.firebasePingTime = 5000;
		}

		if (this.$store.state.user.logedin == false) {
			this.$store.commit("setLoader", false);
			this.$router.push("/login");
			return false;
		}
		this.user_id = this.$store.getters.getUserId;
		this.$store.commit("setLoader", true);
		this.$store.dispatch("getVideoById", this.$route.params.vid).then((res) => {
			this.video_name = res._embedded.collections[0].name;
			this.$store
				.dispatch("getVideoPlaybackURLV2", {
					videoId: this.$route.params.vid,
					deviceId: this.duidVal,
				})
				.then((res) => {
					this.session_id = res.response.sessionId;
					this.jsonDataToBase64Data();
					if ( res.response.url) {
						this.playbackURL = res.response.url;
					}
					this.showVideo = true;
					this.firebaseData();
					this.$store.commit("setLoader", false);
				})
				.catch((err) => {
					if (err.response.data.error.status == "422") {
						this.showVideo = false;
						this.showScreenLimitError = true;
						// show upgrade screen popup
					}
					if (err.response.data.error.status == "403") {
						this.showPopup = true;
						// this.$router.push("/account");
						// this.$store.commit(
						//   "setNotification",
						//   "Please add your subscription to Play Video"
						// );
						document.exitFullscreen();
					}
					if (err.response.data.error.status == "404") {
						this.$router.push("/home");
						this.$store.commit("setNotification", "Please try again later");
						document.exitFullscreen();

						this.$store.commit("setLoader", false);
					}
					this.$store.commit("setLoader", false);
				});
		});
	},
};
</script>

<style scoped>
.container {
	align-items: center;
	padding-top: 20%;
}
.card {
	border-radius: 20px;
}
.buttons {
	display: flex !important;
	justify-content: center !important;
	padding-bottom: 30px;
	padding-top: 30px;
}

.upgrade-plan > p {
	padding-top: 0px;
	padding-bottom: 10px;
	margin-top: 0px;
	margin-bottom: 0px;
	font-size: 20px;
	text-align: center;
	display: flex !important;
	justify-content: center !important;
}
.upgrade-heading {
	display: flex !important;
	justify-content: center !important;
}

.heading {
	display: flex !important;
	justify-content: center !important;
}

.notfound-container {
	content: "";
	position: absolute;
	left: 0;
	top: 0;
	display: block;
	width: 100%;
	min-height: 100vh;
	background-blend-mode: overlay;
	background-color: rgba(103, 159, 61, 0.88);
}

.screen-limit {
	background: #679f3d;
	color: #f1f2f2;
	text-align: center;
	height: 100vh;
	display: flex;
	flex-direction: column;
	justify-content: center;
}
</style>
